import React, { useEffect, useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
const WEBSOCKET_URL = "wss://chatsocket.a2logicgroup.com";
// const WEBSOCKET_URL = "ws://localhost:8084";
export default function Dashboard() {
  const storedToken = localStorage.getItem("adminToken");
  const navigate = useNavigate();
  const AdminName = localStorage.getItem("username");
  const isAdmin = localStorage.getItem("isAdmin");
  const [username, setUsername] = useState(AdminName);
  const [chat, setChat] = useState({});
  const [ws, setWs] = useState(null);
  const [ChatUpdate, setChatUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [withdrawals, setWithdrawals] = useState([]);
  const [TransactionId, setTransactionId] = useState([]);
  const [TotalDeposit, setTotalDeposit] = useState([]);
  const [TotalWithdrawal, setTotalWithdrawal] = useState([]);
  const [totalprofitloss, setTotalProfitLoss] = useState([]);
  const [adminProfitLoss, setAdminProfitLoss] = useState(0);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
  });

  useEffect(() => {
    if (!isAdmin === "true") {
      navigate("/");
      localStorage.clear()
    }
  }, [!isAdmin]);

  useEffect(() => {
    const websocket = new WebSocket(WEBSOCKET_URL);

    websocket.onopen = () => console.warn("Connected to WebSocket");

    websocket.onmessage = (event) => {
      try {

        if (isAdmin) {

          fetchMessages();
        }

      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };
    websocket.onclose = () => console.log("WebSocket disconnected");
    websocket.onerror = (error) => console.error("WebSocket error:", error);
    setWs(websocket);
    return () => websocket.close();
  }, []);
  const fetchMessages = () => {


    fetch(`${process.env.REACT_APP_API_URL}messagesCount`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {

        setChat(data);
        console.log(data)
      })
      .catch((error) => {
        console.error("❌ Error fetching messages:", error);
      });
  };

  useEffect(() => {

    fetchMessages();

  }, [isAdmin]);


  useEffect(() => {
    loadWithdrawals(selectedDate);
  }, []);

  // const loadWithdrawals = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(`${process.env.REACT_APP_API_URL}user/transaction-history`);

  //     // Get all transactions
  //     const transactions = response.data.transactions || [];

  //     setTotalDeposit(response.data.totalDeposit);
  //     setTotalWithdrawal(response.data.totalWithdrawal);
  //     setTotalProfitLoss(response.data.profitOrLoss);

  //     // Set withdrawals (only Deposit transactions)
  //     const filteredWithdrawals = transactions.filter(
  //       (transaction) => transaction.type === "Deposit"
  //     );
  //     setWithdrawals(filteredWithdrawals);

  //     const ids = transactions.map((transaction) => transaction._id);
  //     setTransactionId(ids);  // ✅ Corrected state function name

  //   } catch (error) {
  //     console.error("❌ Error fetching withdrawal transactions:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const loadWithdrawals = async (date = "") => {
    setLoading(true);
    try {
      // ✅ 1. Always fetch full transaction history (All Time)
      const fullResponse = await axios.get(`${process.env.REACT_APP_API_URL}user/transaction-history`);
      const allTransactions = fullResponse.data.transactions || [];
  
      setTotalDeposit(fullResponse.data.totalDeposit);          // All-time
      setTotalWithdrawal(fullResponse.data.totalWithdrawal);    // All-time
      setWithdrawals(allTransactions);                          // All-time
      setTransactionId(allTransactions.map(t => t._id));        // All-time
  
      // ✅ 2. Profit/Loss filtered by selected date (if any)
      if (date) {
        const filteredResponse = await axios.get(`${process.env.REACT_APP_API_URL}user/transaction-history`, {
          params: { date }
        });
        setTotalProfitLoss(filteredResponse.data.userProfitOrLoss);  // Filtered by date
        setAdminProfitLoss(filteredResponse.data.adminProfitOrLoss); // Filtered by date
      } else {
        // Default to full (All Time)
        setTotalProfitLoss(fullResponse.data.userProfitOrLoss);
        setAdminProfitLoss(fullResponse.data.adminProfitOrLoss);
      }
  
    } catch (error) {
      console.error("❌ Error fetching withdrawal transactions:", error);
    } finally {
      setLoading(false);
    }
  };
  
  
  
  return (
<div className="date-filter-container">
<div className="mt-3">
        <label>Select Date: </label>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => {
            const date = e.target.value;
            setSelectedDate(date);
            loadWithdrawals(date);
          }}
        />
      </div>


      <Row className="g-4 mt-2">
        {/* Seen Box */}
        {/* <Col md={6} lg={3}>
          <Card 
          className="shadow-sm text-center overflow-hidden" 
          onClick={() => navigate("/user") }
          style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-eye-fill fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Seen</Card.Title>
                <Card.Text className="cardtext">{chat.seen}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col> */}

        {/* Unseen Box */}
        {/* <Col md={6} lg={3}>
          <Card 
          className="shadow-sm text-center overflow-hidden" 
          onClick={() => navigate("/user") }
          style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-eye-slash-fill fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Unseen</Card.Title>
                <Card.Text className="cardtext">{chat.unseen}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col> */}

        {/* Deposit Box */}
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/deposit")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-cash-stack fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Deposit</Card.Title>
                <Card.Text className="cardtext">{TotalDeposit}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Withdrawal Box */}
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/withdraw")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-wallet2 fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Withdrawal</Card.Title>
                <Card.Text className="cardtext">{TotalWithdrawal}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Deposit Chat */}
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/user")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-chat-dots fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Deposit Chat</Card.Title>
                <Card.Text className="cardtext">{chat.Totaldepositchat}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/user")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
              <i class="bi bi-graph-up-arrow fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Users Profit & Loss</Card.Title>
                <Card.Text
                  className="cardtext"
                  style={{ color: totalprofitloss < 0 ? "red" : "green" }}
                >
                  {totalprofitloss}
                </Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} lg={3}>
        <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/user")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
              <i class="bi bi-graph-up fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Admin Profit & Loss</Card.Title>
                <Card.Text
                  className="cardtext"
                  style={{ color: adminProfitLoss < 0 ? "red" : "green" }}
                >
                  {adminProfitLoss}
                </Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Withdrawal Chat */}
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/user")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-chat-left-text fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Withdrawal Chat</Card.Title>
                <Card.Text className="cardtext">{chat.Totalwithdrawchat}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>



        {/* User Count */}
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/user")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-people fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Users</Card.Title>
                <Card.Text className="cardtext">{chat.totaluserCount}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Total Links */}
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            onClick={() => navigate("/link")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-link-45deg fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Total Links</Card.Title>
                <Card.Text className="cardtext">{chat.totalLinks}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>


    </div>

  );
}